import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesunitTemp } from '../../../entities/salesunit-temp.model';
import {Booth, BoothType, Contact, EnergyPriceType, Marketdate, Salesunit, SalesunitStatus} from '../../../entities';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';
import { Observable } from 'rxjs/Observable';
import { LocalStorageService } from 'ng2-webstorage';
import { isNumeric } from 'rxjs/util/isNumeric';
import {AssortmentService} from '../../../shared/services/assortment.service';
import {Assortment} from '../../../entities/assortment.model';
import { TRAINING } from '../../../app.constants';
import {classToClass} from 'class-transformer';

@Component({
  selector: 'app-salesunit-detail',
  templateUrl: './salesunit-detail.component.html',
  styles: []
})
export class SalesunitDetailComponent implements OnInit {

  merchant: Contact;

  salesunitBefore: SalesunitTemp;
  salesunitAfter: SalesunitTemp;
  salesunitResult: SalesunitTemp;

  causingMarketMaster: Contact;
  causedOnMarketdate: Marketdate;

  modalRef: any = null;

  loadingIndicator = true;

  useLastMarketDetail: boolean;
  lastMarketDetail: string;
  lastMarketDetailTitle: string;

  assortments: Assortment[] = [];
  assortmentBefore: Assortment[] = [];
  assortmentAfter: Assortment[] = [];
  selectedAssortments: any[] = [];
  groupLabels = {
    '67/1': 'Grüner Markt',
    '67/2': 'Erweiterter Markt'
  };

  archive: boolean;
  duplicatesLoading: boolean;
  @ViewChild('duplicateSalesunitModal') private duplicateSalesunitModal;
  possibleDuplicates: Salesunit[];
  possibleDuplicatesOriginal: Salesunit[];
  selectedDuplicate: Salesunit | SalesunitTemp;
  marketdateBooths: Booth[];
  maxAssortmentsPerSalesunit = 3;
  salesunitAssortmentTypeBefore: string;
  salesunitAssortmentTypeAfter: string;

  trainingSystem = TRAINING;

  industrialCodes = [];
  revokingData: boolean;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              public router: Router,
              private jhiLanguageService: JhiLanguageService,
              private modalService: NgbModal,
              private localStorage: LocalStorageService,
              private assortmentService: AssortmentService) {
    this.jhiLanguageService.setLocations(['base-data']);
    this.archive = this.router.url.split('/company')[0] === '/base-data-archive';
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const salesunitId = +params['id'];
      this.load(salesunitId);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.useLastMarketDetail = (queryParams && queryParams['useLastMarketDetail']) || false;
      if (this.useLastMarketDetail) {
        this.lastMarketDetail = this.localStorage.retrieve('lastMarketDetail');
        this.lastMarketDetailTitle = this.localStorage.retrieve('lastMarketDetailTitle');
      }
    });
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

  load(id: number) {

    const apiPath = this.archive ? 'salesunit-temps-changes-by-original-archived/' : 'salesunit-temps-changes-by-original/';

    this.assortmentService.getAssortments().then((data) => {
      this.assortments = data;
      this.industrialCodes = [...Array.from(new Set(this.assortments.map(a => a.industrialCode)))];
    });
    this.apiService.findRegular<SalesunitTemp>(SalesunitTemp, apiPath + id).subscribe(
      salesunit => {
        this.loadingIndicator = false;
        this.salesunitBefore = salesunit.filter((item) => item.status === 'Before')[0];
        this.salesunitAfter = salesunit.filter((item) => item.status === 'After' || item.status === 'New')[0];
        this.salesunitResult = classToClass(this.salesunitAfter); // deep clone

        if (!this.salesunitBefore) {
          this.salesunitBefore = new SalesunitTemp(true);
        }

        if (this.salesunitBefore && this.salesunitAfter) {
          if (this.salesunitBefore.assortmentKeys) {
            this.assortmentBefore = this.assortmentService.selectAssortmentsFromString(this.salesunitBefore.assortmentKeys)
              .filter(() => true);
            this.salesunitAssortmentTypeBefore = this.assortmentService.assortmentTypeFromKeyStrings(
              this.assortmentService.assortmentKeyStringArrayFromString(this.salesunitBefore.assortmentKeys));
          } else {
            this.assortmentService.getAssortments().then(
              (assortments) => this.assortmentBefore = assortments
            );
          }
          if (this.salesunitAfter.assortmentKeys) {
            this.assortmentAfter = this.assortmentService.selectAssortmentsFromString(this.salesunitAfter.assortmentKeys)
              .filter(() => true);
            this.changeSelectedAssortments(this.assortmentAfter);
            this.salesunitAssortmentTypeAfter = this.assortmentService.assortmentTypeFromKeyStrings(
              this.assortmentService.assortmentKeyStringArrayFromString(this.salesunitAfter.assortmentKeys));
          } else {
            this.assortmentService.getAssortments().then(
              (assortments) => this.assortmentAfter = assortments
            );
          }
        }


        if (!this.salesunitBefore.energyTypeWinter) {
          this.salesunitBefore.energyTypeWinter = EnergyPriceType.Null;
        }

        this.merchant = this.salesunitAfter.merchant;

        this.causedOnMarketdate = this.salesunitAfter.marketdate;

        this.getMarketdateBooths().then((marketdateBooths => {
          this.marketdateBooths = marketdateBooths;
          this.loadingIndicator = false;

          this.marketdateBooths.forEach(
            (marketdatebooth) => {
              if (marketdatebooth.marketdate.id === this.causedOnMarketdate.id) {
                  this.getContactByUserId(marketdatebooth.updatedBy.id)
                    .subscribe(causingMm => this.causingMarketMaster = causingMm);
              }
            }
          );

        }));

        this.findSimilarSalesunits();
      }, error => this.loadingIndicator = false
    );
  }

  getMarketdateBooths(): Promise<any> {
    return new Promise<any>(resolve => {
      const url = 'marketdate-booths-by-salesunit/' + this.salesunitAfter.originalSalesunit.id;
      this.apiService.find<Booth>(Booth, url)
        .subscribe(marketdateBooths => {
          resolve(marketdateBooths);
        });
    });
  }

  acceptData() {
    this.loadingIndicator = true;
    this.duplicatesLoading = true;


    this.assortmentAfter.forEach((assortment) => {
      assortment.checked = this.selectedAssortments.some(item => item.keyNumber === assortment.keyNumber);
    });

    if (this.salesunitAfter.status !== 'New' || this.selectedDuplicate === this.salesunitAfter) {
      this.loadingIndicator = true;
      this.salesunitAfter = this.salesunitResult;
      this.salesunitAfter.assortmentKeys = this.assortmentService.assortmentsToKeyString(this.assortmentAfter, true);

      // const assortmentAdditionalAfter = this.assortmentAdditionalAfter.filter(opt => opt.checked).map(opt => opt.value);
      // this.salesunitAfter.assortmentAdditional = assortmentAdditionalAfter.join(' | ');

      const originalSalesunit = this.salesunitAfter.originalSalesunit;

      const companyId = this.salesunitAfter.merchant.id;

      /*
      // Delete the corresponding contactTemps
      this.apiService.delete('salesunit-temps-delete-by-original/' + originalSalesunit.id).subscribe();
      */

      // Update the original contact
      this.salesunitAfter.id = originalSalesunit.id;
      this.salesunitAfter.status = 'Accepted';

      // Update booth sizes
      this.salesunitAfter.boothSize = Math.ceil(this.salesunitAfter.boothWidth * this.salesunitAfter.boothDepth);
      if (this.salesunitAfter.boothWidthWinter && this.salesunitAfter.boothDepthWinter
        && this.salesunitAfter.boothWidthWinter > 0 && this.salesunitAfter.boothDepthWinter > 0) {
        this.salesunitAfter.boothSizeWinter = Math.ceil(this.salesunitAfter.boothWidthWinter * this.salesunitAfter.boothDepthWinter);
      }

      this.apiService.putRegular(this.salesunitAfter, 'salesunits/' + this.causedOnMarketdate.id).subscribe(
        response => {
          this.loadingIndicator = false;
          this.duplicatesLoading = false;
          if (this.modalRef) {
            this.modalRef.close();
          }
          this.router.navigate(['/base-data/company', companyId], {queryParamsHandling: 'preserve'});
        }, error => {
          this.loadingIndicator = false;
          this.duplicatesLoading = false;
        });
    } else {
      this.salesunitAfter = this.salesunitResult;
      const url = 'use-duplicate-salesunit/';
      const marketdateBoothId = ((this.marketdateBooths && this.marketdateBooths.length >= 1) ? this.marketdateBooths[0].id : 0).toString();
      this.apiService.get(url + this.salesunitAfter.originalSalesunit.id + '/' + this.selectedDuplicate.id + '/' + marketdateBoothId)
        .subscribe(result => {
          const merchantId = result.json();

          if (this.checkForDuplicateChanges()) {
            this.selectedDuplicate.status = SalesunitStatus.AcceptedWithChanges;
            this.selectedDuplicate.boothSize = Math.ceil(this.selectedDuplicate.boothWidth * this.selectedDuplicate.boothDepth);
            if (this.selectedDuplicate.boothWidthWinter && this.selectedDuplicate.boothDepthWinter
              && this.selectedDuplicate.boothWidthWinter > 0 && this.selectedDuplicate.boothDepthWinter > 0) {
              this.selectedDuplicate.boothSizeWinter = Math.ceil(this.selectedDuplicate.boothWidthWinter
                * this.selectedDuplicate.boothDepthWinter);
            }
            this.apiService.putRegular(this.selectedDuplicate, 'salesunits/' + this.causedOnMarketdate.id).subscribe(
              response => {
                this.loadingIndicator = false;
                this.duplicatesLoading = false;

                if (this.modalRef) {
                  this.modalRef.close();
                }
                this.router.navigate(['/base-data/company', merchantId], {queryParamsHandling: 'preserve'}).then();
              }, error => {
                this.loadingIndicator = false;
                this.duplicatesLoading = false;

                if (this.modalRef) {
                  this.modalRef.close();
                }
                this.router.navigate(['/base-data/company', merchantId], {queryParamsHandling: 'preserve'}).then();
              });
          } else {
            if (this.modalRef) {
              this.modalRef.close();
            }
            this.router.navigate(['/base-data/company', merchantId], {queryParamsHandling: 'preserve'}).then();
          }
      });
    }
  }

  revokeData() {
    this.revokingData = true;
    const originalSalesunit = this.salesunitAfter.originalSalesunit;

    const companyId = this.salesunitAfter.merchant.id;

    // Revoke the corresponding salesunitTemps
    const revokePromise = new Promise((resolve, reject) => {
      this.apiService.get('salesunit-temps-revoke-by-original/' + originalSalesunit.id).subscribe(() => {
        resolve();
      }, error => reject(error));
    });

    Promise.all([revokePromise]).then(() => {
      this.revokingData = false;
      if (this.modalRef) {
        this.modalRef.close();
      }
      this.router.navigate(['/base-data/company', companyId], {queryParamsHandling: 'preserve'}).then();
    }, error => this.revokingData = false);

  }

  getContactByUserId(userId: number): Observable<Contact> {
    return this.apiService.findOne<Contact>(Contact, 'contact-by-user/' + userId);
  }

  checkDuplicates() {
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.findSimilarSalesunits();
    this.openModal(this.duplicateSalesunitModal, {size: 'lg', windowClass: 'xl'});
  }

  filterAssortments(assortments: any[]) {
    return assortments.filter((item) => item.checked);
  }

  findSimilarSalesunits() {
    this.duplicatesLoading = true;
    this.apiService.find<Salesunit>(Salesunit, 'similar-salesunits/' + this.salesunitAfter.originalSalesunit.id)
      .subscribe((duplicatesResult: Salesunit[]) => {
        this.possibleDuplicates = duplicatesResult;

        this.possibleDuplicatesOriginal = [];
        this.possibleDuplicates.forEach((su: Salesunit) =>
          this.possibleDuplicatesOriginal.push(Object.assign<Salesunit, Salesunit>(new Salesunit(), (su as Salesunit))));

        this.selectedDuplicate = this.salesunitAfter;
        this.duplicatesLoading = false;
      });
  }

  getDuplicateHint(): string {
    let result = 'Es wurde mindestens ein mögliches Duplikat zu der neu erfassten Verkaufseinheit gefunden.';
    if (this.possibleDuplicates && isNumeric(this.possibleDuplicates.length)) {
      switch (this.possibleDuplicates.length) {
        case 1:
          result = 'Es wurde ' + this.possibleDuplicates.length + ' mögliches Duplikat zu der neu erfassten Verkaufseinheit gefunden.';
          break;
        default:
          result = 'Es wurden ' + this.possibleDuplicates.length + ' mögliche Duplikate zu der neu erfassten Verkaufseinheit gefunden.';
          break;
      }
    }
    return result;
  }

  changeSelectedDuplicate(selected) {
    this.selectedDuplicate = (selected !== this.selectedDuplicate) ? selected : null;
  }

  isNotNullOr0(val) {
    return (val !== null) && (val !== 0);
  }

  checkForDuplicateChanges(): boolean {
    const selectedSalesunit = this.selectedDuplicate;
    const selectedSalesunitOriginal = this.possibleDuplicatesOriginal.find(su => su.id === selectedSalesunit.id);
    return (JSON.stringify(selectedSalesunit) !== JSON.stringify(selectedSalesunitOriginal));
  }

  changeSalesunitIdentificationData(salesunit: SalesunitTemp) {
    if (salesunit.licensePlate) {
      salesunit.licensePlate = salesunit.licensePlate.toUpperCase();
    }
    let sqmPart = Math.ceil(salesunit.boothWidth * salesunit.boothDepth).toString();

    if (salesunit.useWinterSize
      && salesunit.boothDepthWinter && salesunit.boothDepthWinter > 0
      && salesunit.boothWidthWinter && salesunit.boothWidthWinter > 0) {
      sqmPart = Math.ceil(salesunit.boothWidthWinter * salesunit.boothDepthWinter).toString();
    }

    if (salesunit.boothType
      && salesunit.boothWidth && salesunit.boothWidth > 0
      && salesunit.boothDepth && salesunit.boothDepth > 0) {
      switch (salesunit.boothType) {
        case BoothType.Car:
          if (salesunit.licensePlate && salesunit.licensePlate !== '') {
            salesunit.identification = 'VM_'
              + salesunit.licensePlate
              + '_' + sqmPart + ' qm';
          } else {
            salesunit.identification = '';
          }
          break;
        case BoothType.Trailer:
          if (salesunit.licensePlate && salesunit.licensePlate !== '') {
            salesunit.identification = 'VA_'
              + salesunit.licensePlate
              + '_' + sqmPart + ' qm';
          } else {
            salesunit.identification = '';
          }
          break;
        case BoothType.Stall:
          salesunit.licensePlate = '';
          salesunit.identification = 'VS_'
            + ((salesunit.salesunitNumber === 1) ? 'Normalfläche' : salesunit.marketdayNumber)
            + '_' + sqmPart + ' qm';

          if (salesunit.salesunitNumber > 1) {
            // MarketdayNumber is used by ERP to determine if to use 'Normalfläche' or the respective number
            salesunit.marketdayNumber = salesunit.marketdate.marketday.marketdayNumber;
          }
          break;
        default:
          salesunit.identification = '';
          break;
      }
    } else {
      salesunit.identification = '';
    }
  }

  getNumberOfSelectedAssortments() {
    if (this.assortmentAfter) {
      return this.assortmentAfter.filter(assortment => assortment.checked).length;
    } else {
      return 0;
    }
  }

  updateSelectedAssortment(selected) {
    this.selectedAssortments = selected;
  }

  /**
   * Updates selected assorttment type
   */
  updateSelectedAssortmentType() {
    const result = this.assortments.filter((item) =>
      this.selectedAssortments.some((selected) => selected.keyNumber === item.keyNumber));
    if (result.length > 0) {
      this.salesunitAssortmentTypeAfter = result[0].industrialCode;
    } else {
      this.salesunitAssortmentTypeAfter = null;
    }
  }

  /**
   * Check if given assortment is selected
   */
  isAssortmentSelected(option: Assortment) {
    return this.selectedAssortments.some((item) => item === option.keyNumber);
  }

  /**
   * Overrides this.selectedAssortments (array of keyNumbers) with the given Assortment Array
   */
  changeSelectedAssortments(assortments: Assortment[]) {
    this.selectedAssortments = this.filterAssortments(assortments);
    this.updateSelectedAssortmentType();
  }

  /**
   * Checks if the assortment with the given index has changed
   */
  hasAssortmentChanged(item: Assortment): boolean {
    return !this.filterAssortments(this.assortmentBefore).some((a: Assortment) => a.keyNumber === item.keyNumber);
  }
}



// WEBPACK FOOTER //
// ./src/app/base-data/components/salesunit-detail/salesunit-detail.component.ts